// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavbarItem_navbarItem__D1-3q","navBarItemIcon":"NavbarItem_navBarItemIcon__M3SC0","itemContent":"NavbarItem_itemContent__Wl77Z"};